import React, { useContext } from "react";
import { Container, Grid, Typography, Box, Link } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import footerBg from "../../assets/footer-bg.png";
import LocationOnIcon from '@mui/icons-material/LocationOn';

const Footer = () => {


  return (
    <>
      <Box className="footer-container" sx={{
        backgroundImage: `url(${footerBg})`,
        py: {
          xs: 2,
          sm: 1,
          md: 3
        }
      }}
      >
        <Container disableGutters sx={{ position: 'relative', zIndex: 1 ,marginLeft:0,marginRight:0}} style={{maxWidth:'none'}}>
          <Grid container spacing={2} justifyContent="center" alignItems="stretch">
            {/* About Us Section */}
            <Grid item xs={12} md={4} sx={{ maxWidth: '400px' }}>
              <Box className="footer-about-box">
                <Typography variant="h5" component="h2" className="footer-about">
                  About us
                </Typography>
                <Typography variant="body1" className="footer-about-body">
                  Our company lies in manufacturing and supplying colourful crackers. We are equipped with a state of art infrastructural unit and production facility. In order to cater to the growing demands of our clients.
                </Typography>
              </Box>
            </Grid>

            {/* Contact Info Section */}
            <Grid item xs={12} md={4}>
              <Box className="footer-contact-box">
                <Typography variant="h5" component="h2" className="footer-contact">
                  Contact Info
                </Typography>
                <Box display="flex" alignItems="center" mb={1} mt={1} className="footer-contact-item">
                  <LocationOnIcon sx={{ mr: 1, color: '#fff' }} />
                  <Typography variant="body1">34, Sivakasi, 620 189</Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={1} className="footer-contact-item">
                  <PhoneIcon sx={{ mr: 1, color: '#fff' }} />
                  <Typography variant="body1">+91 89809 98090</Typography>
                </Box>
                <Box display="flex" alignItems="center" mb={1} className="footer-contact-item">
                  <PhoneIcon sx={{ mr: 1, color: '#fff' }} />
                  <Typography variant="body1">+91 89809 98090</Typography>
                </Box>
                <Box display="flex" alignItems="center" className="footer-contact-item">
                  <EmailIcon sx={{ mr: 1, color: '#fff' }} />
                  <Typography variant="body1">svk@gamail.com</Typography>
                </Box>
              </Box>
            </Grid>

            {/* Map Section */}
            <Grid item xs={12} md={4} className="footer-map-box">
              <Box sx={{ width: '500px', height: '250px' }} className="footer-map-iframe">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3928.841369796035!2d76.99026857497184!3d10.77196018933221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7d41f02126e7b%3A0xf63989e246990d0b!2sSivakasi%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1626000000000!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* Footer Bottom */}
        <Box className="footer-bottom">
          <Typography variant="body2" sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' }
          }}>
            Copyright@2025, your crackers. All rights reserved Developed by Stutzen Corporates Private Limited
          </Typography>
        </Box>
      </Box >
    </>
  );
};

export default Footer;